import axios from 'axios';
import router from '@/router';  // Si usas Vue Router

export const BASE_URL = 'https://presware-tuevent.s3.us-east-2.amazonaws.com';

let accessToken = null;
export const setAccessToken = (t) => { accessToken = t; };
export const getAccessToken = () => accessToken;

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
});

// Adjunta Authorization si hay token
api.interceptors.request.use(cfg => {
  if (accessToken) {
    cfg.headers = cfg.headers || {};
    cfg.headers.Authorization = `Bearer ${accessToken}`;
  }
  return cfg;
});

// Helper: detectar si la llamada es de refresh
const isRefreshCall = (url = '') => url.includes('/users/auth/refresh');

// Una sola promesa de refresh en curso (evita tormenta de requests)
let refreshPromise = null;
async function ensureAccessToken() {
  if (!refreshPromise) {
    refreshPromise = api.get('/users/auth/refresh', { __skip401Handler: true })
      .then(({ data }) => {
        setAccessToken(data.accessToken);
        return data.accessToken;
      })
      .finally(() => { refreshPromise = null; });
  }
  return refreshPromise;
}

// Respuestas: si 401, intenta refresh y reintenta la original
api.interceptors.response.use(
  r => r,
  async err => {
    const original = err.config;
    const status = err.response?.status;

    // Si no hay config, o explícitamente debemos saltarnos el handler, fuera
    if (!original || original.__skip401Handler) {
      return Promise.reject(err);
    }

    if ((status === 401 || status === 403) && !original._retry && !isRefreshCall(original.url)) {
      original._retry = true;
      try {
        const token = await ensureAccessToken();
        original.headers = original.headers || {};
        original.headers.Authorization = `Bearer ${token}`;
        return api.request(original);
      } catch (e) {

        setAccessToken(null);
        router.replace('/');
        return Promise.reject(e);
      }
    }

    return Promise.reject(err);
  }
);

export default api;